import { Component, OnInit, ViewChild } from '@angular/core';
import { Invoices as InvoicesService } from '../invoices.service'
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormatNumberInputProvider } from '../../../shared/components/format-number-input/format-number-input.component';
import { ConfigService } from 'src/assets/environments/ConfigService';
import { Item } from '../item.model';
// import { ItemSignPopupService } from '../item-popup.service';
import { CONFIG } from 'src/app/shared/constants/config.constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import * as Moment from 'moment';
import { isNumeric } from "rxjs/util/isNumeric"
import { PopupService } from '../../../shared/services/popup/popup.service';
import { LocalStorageService } from 'ng2-webstorage';
import { ItemPopupService } from '../../invoice-html/item-popup.service';
import { TemplateType } from 'src/app/shared/utils/template-type';
import { ItemService } from "../../../Layout/main/item.service";
@Component({
	selector: 'app-invoice-list',
	templateUrl: './invoice-list.component.html',
	styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {
	VerificationCode: string = ''
	item: any;
	itemDetails: any;
	invoiceItems: any;
	isMultiTax: number;
	companyID: string;
	beRelease: any;
	hasBeRelease: boolean;
	items: Item[];
	shemaUrl: any;
	thanhcong: boolean = false;
	session: any;
	_rowID = 0;
	_rowCompanyID = 0;
	_rowClientID = 0;
	_rowVerificationCode = '';
	isUp: number = 0;
	isTaxUp: number = 0;
	isSearched: boolean = false;
	isSearchInvoice: boolean = true;

    capCha: string;
	capChaRequired: string;
	CheckCaptcha: boolean = true;
	searchParams: any
	isErrStartDateRequired: boolean = false;
	isErrEndDateRequired: boolean = false;
	isErrStartDateFormat: boolean = false;
	isErrEndDateFormat: boolean = false;
	isErrEndDateGreaterStartDate: boolean = false;
	isValidDate: boolean = true;
	invoiceId: number = 0;
	invoiceNo: string = '';
	whatBank: any = {};
	isHidedSign: boolean = false;

    @ViewChild('startDateDatePicker') startDateDatePicker: any;
    @ViewChild('endDateDatePicker') endDateDatePicker: any;
	
	constructor(
		private service: InvoicesService,
		private activatedRoute: ActivatedRoute,
		private route: ActivatedRoute,
		private formatNumberInputProvider: FormatNumberInputProvider,
		private config: ConfigService,
		// private itemSignPopupService: ItemSignPopupService,
		private router: Router,
		public activeModal: NgbActiveModal,
        public popupService: PopupService,
		private localStorageService: LocalStorageService,
		private itemPopupService: ItemPopupService,
		private templateType: TemplateType,
		private itemMainService: ItemService
	) {

	}

	ngOnInit() {
		this.bank();
		var ss = sessionStorage.getItem('login');
		if (ss == null || ss == '') {
			this.session = null;
		}
		else {
			this.session = JSON.parse(ss);
			const now = Moment().toObject();
			this.searchParams = {
				id: "0",
				clientId: this.session.clientId,
				dateFrom: {
					year: now.years,
					month: now.months + 1,
					day: now.date
				},
				dateTo: {
					year: now.years,
					month: now.months + 1,
					day: now.date
				}
			};
		}
		setTimeout(() => {
				this.changeCapCha();
			}, 0);
		this.loadconfigCompany();
		//truong hop vao link da co thong tin ma tra cuu
		var type = JSON.parse(this.route.snapshot.queryParamMap.get('type'));
		if(type != null){
			this.isSearchInvoice =  type
			this.VerificationCode =  this.route.snapshot.queryParamMap.get('id');
		}
		if (this.VerificationCode != null && this.VerificationCode != '') {
			this.CheckCaptcha = false;
			this.Search();
		}
	}

	formatSearchParams(searchParams) {
        const formatedSearchParams = JSON.parse(JSON.stringify(searchParams));
        if (formatedSearchParams.dateFrom) {
            formatedSearchParams.dateFrom.month--;
            formatedSearchParams.dateFrom = Moment(formatedSearchParams.dateFrom).format(CONFIG.serverDateFormat);
        }

        if (formatedSearchParams.dateTo) {
            formatedSearchParams.dateTo.month--;
            formatedSearchParams.dateTo = Moment(formatedSearchParams.dateTo).format(CONFIG.serverDateFormat);
        }

        return formatedSearchParams;
    };

    changeCapCha() {
        const str = Math.random().toString(36);
		this.capChaRequired = str.substring(str.length - 5, str.length);
        const canvas = <HTMLCanvasElement> document.getElementById('capChaRequired');
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = '400 30px "Segoe UI"';
        ctx.fillStyle = '#fff';
        ctx.fillText(this.capChaRequired, 1, canvas.height / 2 + 8);
        if (this.capChaRequired.length > 5) {
            this.changeCapCha();
        }
    }

	checkedChange(){
		this.item = null;
		this.isSearched = false;
		this.isSearchInvoice = !this.isSearchInvoice;
	}

	Search() {
		// if (this.VerificationCode == null || this.VerificationCode == '') return;
		if (this.capCha != this.capChaRequired && this.CheckCaptcha){
			setTimeout(() => {
				let messageKey = 'message.capChaNotMatch';
				this.router.navigate([{ outlets: {
					notification: 'notification/' + messageKey
				}}], {
					replaceUrl: true
				});
			});
		} else {
			this.item = null;
			this.isSearched = true;
			//Not Login
			if(this.session == null) {
				if (this.VerificationCode != '') {
					this.loadconfigCompanyByVerifiCode(this.VerificationCode);
					//Check is Search Invoice Or Announcement
					if(this.isSearchInvoice){
						//Search invoice
						this.service.SearchInvoice(this.VerificationCode).subscribe(x => {
							this.item = x;
						});
					} else {
						//Search Announcement
						this.service.SearchAnnouncement(this.VerificationCode).subscribe(x => {
							this.item = x;
							this.settingAnnouncementName(this.item.data);
						});
					}
				}
			}
			//Is Login
			else {
				if(!this.isValidDate){
					return;
				}
				let textSearch: string;
				if(this.VerificationCode == null || this.VerificationCode == ''){
					textSearch = "0";
				}else{
					textSearch = this.VerificationCode;
				}
				this.searchParams.strSearch = textSearch;
				if(this.isSearchInvoice){
					//Search invoice
					if(isNumeric(textSearch) && textSearch.length <= 7){
						this.service.SearchInvoiceByInvoiceNo({ searchParams: this.formatSearchParams(this.searchParams)})
						.subscribe(x => {
							this.item = x
						});
					}else{
						this.service.SearchInvoiceByVeriCodeLogin({ searchParams: this.formatSearchParams(this.searchParams)})
						.subscribe(x => {
							this.item = x
						});
					}
				} else 
				{
					//Search Announcement
					if(isNumeric(textSearch) && textSearch.length <= 7){
						this.service.SearchAnnouncementByInvoiceNo({ searchParams: this.formatSearchParams(this.searchParams)})
						.subscribe(x => {
							this.item = x;
							this.settingAnnouncementName(this.item.data);
						});
					}else{
						this.service.SearchAnnouncementByVeriCodeLogin({ searchParams: this.formatSearchParams(this.searchParams)})
						.subscribe(x => {
							this.item = x;
							this.settingAnnouncementName(this.item.data);
						});
					}
				}
			}
		}
		this.CheckCaptcha = true;
		this.capCha = '';
		this.changeCapCha();
		this.setData();
		this.getHidedSign();
	}

	checkDateFromValid(){
		this.isValidDate = false;
		this.isErrStartDateRequired = false;
		this.isErrStartDateFormat = false;
		this.isErrEndDateGreaterStartDate = false;
		var startDate = this.searchParams.dateFrom;
		var endDate = this.searchParams.dateTo;

		if(this.searchParams.dateFrom == null) {
			this.isErrStartDateRequired = true;
            return
		}
		else if (startDate == null) {
			this.isErrStartDateFormat = true;
            return
		}
		if(endDate){
			if(startDate.year > endDate.year){
				this.isErrEndDateGreaterStartDate = true
				return
			} else if(startDate.year == endDate.year && startDate.month > endDate.month){
				this.isErrEndDateGreaterStartDate = true
				return
			} else if(startDate.year == endDate.year && startDate.month == endDate.month && startDate.day > endDate.day){
				this.isErrEndDateGreaterStartDate = true
				return
			} 
		}
		this.isValidDate = true;
	}
	
	checkDateToValid(){
		this.isValidDate = false;
		this.isErrEndDateRequired = false;
		this.isErrEndDateFormat = false;
		this.isErrEndDateGreaterStartDate = false;
		var startDate = this.searchParams.dateFrom;
		var endDate = this.searchParams.dateTo;

		if(this.searchParams.dateTo == null) {
			this.isErrEndDateRequired = true;
            return
		}
		else if (endDate == null) {
			this.isErrEndDateFormat = true;
            return
		}
		if(startDate){
			if(startDate.year > endDate.year){
				this.isErrEndDateGreaterStartDate = true
				return
			} else if(startDate.year == endDate.year && startDate.month > endDate.month){
				this.isErrEndDateGreaterStartDate = true
				return
			} else if(startDate.year == endDate.year && startDate.month == endDate.month && startDate.day > endDate.day){
				this.isErrEndDateGreaterStartDate = true
				return
			} 
		}
		
		this.isValidDate = true;
	}

	settingAnnouncementName(data: any){
		data.forEach(announcement => {
			switch(announcement.AnnouncementType) { 
				case 1: { 
					announcement.AnnouncementTypeName = 'Điều chỉnh hóa đơn';
				   break; 
				} 
				case 2: { 
					announcement.AnnouncementTypeName = 'Thay thế hóa đơn';
				   break; 
				} 
				default: { 
					announcement.AnnouncementTypeName = 'Hủy hóa đơn';
				   break; 
				} 
			 } 
		});
	}

	viewInvoice(invoiceId: number, companyId: number){
		this.CheckCaptcha = false;
		this.Search();
		this.router.navigate(['/', { outlets: { popup: `invoice-html/${invoiceId}/${companyId}` } }]);
	}

	viewAnnouncement(item: any){
		this.CheckCaptcha = false;
		this.Search();
		let id = item.ID;
		let type = item.AnnouncementType;
		this.router.navigate(['/', { outlets: { popup: `Announcement/Review/${id}/${type}`} }]);
	}

	downloadAnnounPDF(item: any){
		this.CheckCaptcha = false;
		this.Search();
        this.service.downloadAnnounPDF(item.ID, item.CompanyID, (data) => this.downloadFilePDF(data, item));
	}
	
	downloadFilePDF(downloadUrl: any,item?: any) {
		var fileName = "";
		let strTime = Moment(new Date()).format('YYYYMMDDHHmmss');
		if(this.isSearchInvoice){
			//ID_Serial_InvoiceNo_InvoiceDate(DDMMYYYY)_DDMMYYHHMMSS
			fileName = item.ID + '_' + item.Symbol + '_' + item.InvoiceNo + '_' + item.ReleasedDate.substring(0,10).replace(new RegExp('-', 'g'), '')
			fileName = fileName.replace(new RegExp('/', 'g'), '') + '_' + strTime;
		} else
		{
			fileName = this.getFileName(item);
			fileName = fileName.replace(new RegExp('/', 'g'), '');
		}
		let link = document.createElement('a');
		link.href = downloadUrl;
		link.download = `${fileName}.pdf`;
		link.click();
		link = null;
		//truong hop download invoice -> kiem tra va download bang ke va phan thuong 
		if(this.isSearchInvoice){
			setTimeout(() => {
				// document.body.removeChild(link);
				window.URL.revokeObjectURL(downloadUrl);
				this.service.getListStatiscal(this.invoiceId).subscribe((item) => {
					var items = item;
					if(items.length > 0){
						this.downloadStatiscal(this.invoiceId);
					}
				});
				this.service.getListGift(this.invoiceId).subscribe((item) => {
					var items = item;
					if(items.length > 0){
						this.downloadGift(this.invoiceId);
					}
				});
			});
		}
	}

	downloadFile(downloadUrl: any, item: any) {
		let link = document.createElement('a');
		var fileName = "";
		let strTime = Moment(new Date()).format('YYYYMMDDHHmmss');
		if(this.isSearchInvoice){
			//ID_Serial_InvoiceNo_InvoiceDate(DDMMYYYY)_DDMMYYHHMMSS
			fileName = item.ID + '_' + item.Symbol + '_' + item.InvoiceNo + '_' + item.ReleasedDate.substring(0,10).replace(new RegExp('-', 'g'), '')
			fileName = fileName.replace(new RegExp('/', 'g'), '') + '_' + strTime;
		} else
		{
			fileName = this.getFileName(item);
			fileName = fileName.replace(new RegExp('/', 'g'), '');
		}
		link.href = downloadUrl;
		//ID_Serial_InvoiceNo_InvoiceDate(DDMMYYYY)_DDMMYYHHMMSS
		link.download = fileName;
		document.body.appendChild(link);
		link.click();
		link = null;

		setTimeout(() => {
				document.body.removeChild(link);
				window.URL.revokeObjectURL(downloadUrl);
		});
		// link = null;
	}
	
    downloadStatiscal(id:number){
        this.service.downloadStatiscal(id, (data) => this.downloadFileStatiscal(data));
	}
	
    downloadFileStatiscal(downloadUrl: any) {
        let link = document.createElement('a');
        link.href = downloadUrl;
        link.download = this.invoiceId + '_' + this.invoiceNo + '_statistical_'+ Moment(new Date()).format('YYYYMMDDHHmmss') +'.pdf';
        document.body.appendChild(link);
        link.click();
		link = null;
        setTimeout(() => {
            // document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        });
	}
	
    downloadGift(id:number){
        this.service.downloadGift(id, (data) => this.downloadFileGift(data));
	}

    downloadFileGift(downloadUrl: any) {
        let link = document.createElement('a');
        link.href = downloadUrl;
        link.download = this.invoiceId + '_' + this.invoiceNo + '_invoiceGift_'+ Moment(new Date()).format('YYYYMMDDHHmmss') +'.pdf';
        document.body.appendChild(link);
        link.click();
        link = null;

        setTimeout(() => {
            // document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        });
    }

    getFileName(item: any){
        var name = '';
        var strfileName = '';
        if(item.AnnouncementType == 1){
            name = 'BBDCHD';
        }else if(item.AnnouncementType == 2){
            name = 'BBTTHD';
        }else if(item.AnnouncementType == 3){
            name = 'BBHHD';
		}
        if (item.MinutesNo == null){
            strfileName = item.ID + '_' + name + '_' + item.InvoiceNo;
        }else
        {
            strfileName = item.ID + '_' + item.MinutesNo + '_' + name + '_' + item.InvoiceNo;
            //ID_Số biên bản_(Nếu không sử dụng số tăng tự động thì sử dụng BBDCHD/BBTTHD/BBHHD)_InvoiceNo_DDMMYYHHMMSS
            if (item.MinutesNo.indexOf(name) > -1){
                strfileName = item.ID + '_' + item.MinutesNo + '_' + item.InvoiceNo;
            }
        }
		let strTime = Moment(new Date()).format('YYYYMMDDHHmmss');
        return strfileName + '_' + strTime;
    }

	downloadPdf(item: any) {
		this.invoiceId = item.ID;
		this.invoiceNo = item.InvoiceNo;
		this.CheckCaptcha = false;
		this.Search();
		this.service.downloadPDF(this.invoiceId, (data) => this.downloadFilePDF(data,item));
	}

	downloadXml(item: any) {
		this.invoiceId = item.ID;
		this.invoiceNo = item.InvoiceNo;
		this.CheckCaptcha = false;
		this.Search();
		this.service.downloadXML(this.invoiceId, (data) => this.downloadFile(data,item));
	}

	loadconfigCompany() {
		this.companyID = this.config.getApi('COMPANYID');
		if (this.session == null || this.session === null) {
			this.companyID = this.config.getApi('COMPANYID');
		}
		else {
			this.session;
		}
	}

	loadconfigCompanyByVerifiCode(veridiCode: string) {
		var typeSearch = "";
		if(this.isSearchInvoice){
			typeSearch = "1";
		}
		else
		{
			typeSearch = "2";
		}
		this.service.getCompanyIdByCode(typeSearch,veridiCode).subscribe((result) => {
			this.companyID = result;
			this.localStorageService.store('companyID',this.companyID);
		});
	}
	
	save() {
		if(this.isSearchInvoice){
			// Start Ký hoa don
			debugger;
			let shemaSign = window['schemaSign'] || CONFIG.schemaSign;
			shemaSign = shemaSign.replace('token', this.session.token);
			this.shemaUrl = shemaSign.replace('releaseId', this._rowID);
			this.shemaUrl += ',1';
			const link = document.createElement('a');
			link.href = this.shemaUrl;
			link.click();
			setTimeout(() => {
				this.activeModal.dismiss(true);
			}, 500);
			this.thanhcong = true;
		} 
		else{
			// Start Ký biên bản
            let shemaSign = window['schemaSign'] || CONFIG.schemaSign;
            shemaSign = shemaSign.replace('token', this.session.token);
			this.shemaUrl = shemaSign.replace('releaseId', this._rowID);
			//sign client => + ',1'(param2)
            this.shemaUrl += ',1';
			//sign announcement => + ',1'(param3)
            this.shemaUrl += ',1';
            const link = document.createElement('a');
			link.href = this.shemaUrl;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(this.shemaUrl);
                this.activeModal.dismiss(true);
			}, 500);
			
			this.thanhcong = true;
		}
	}

	SetID(ID: number, companyID: number, ClientID: number, VerificationCode: string) {
		this._rowID = ID;
		this._rowCompanyID = companyID;
		this._rowClientID = ClientID;
		this._rowVerificationCode = VerificationCode
	}
	setData(){
		this.itemPopupService.setIsCheckXml(false);
	}
	// actionPrintExchange(item: any) {
    //     setTimeout(() => {
    //         this.router.navigate([{ outlets: { 
    //             popup: 'request-convert/'+ item.ID} }], {
    //                 replaceUrl: true
    //             });
    //     }, 1);
	// }
	
	// OpenPopupCreate() {
    //     this.popupService.openComponent(AnnouncementCreateComponent as Component, {}); 
    // }

	bank() {
		return this.templateType.whatBank(this.whatBank);
	}

	getHidedSign() {
		this.itemMainService.getHidedSign().subscribe(result => {
		  this.isHidedSign = JSON.parse(result);
		});
	}

}
